<script setup lang="ts">
//#region types
interface Props {
  disabled?: boolean;
  prependBorder?: boolean;
}
//#endregion

//#region define
const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  prependBorder: true,
});
//#endregion
</script>

<template>
  <div
    class="ui-input-wrapper"
    :class="{
      'ui-input-wrapper_disabled': disabled,
    }"
  >
    <div class="ui-input-wrapper__prepend">
      <slot name="prepend" />
    </div>
    <slot />
    <div
      v-if="prependBorder"
      class="ui-input-wrapper__prepend-border"
    />
    <div class="ui-input-wrapper__append">
      <slot name="append" />
    </div>
  </div>
</template>

<style lang="scss">
.ui-input-wrapper {
  position: relative;

  &_disabled &__prepend,
  &_disabled &__append {
    opacity: 0.5;
  }

  &__prepend,
  &__append {
    &:empty {
      display: none;
    }
  }

  &__prepend {
    position: absolute;
    z-index: 100;
    width: 30px;
    top: 0;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
  }

  &__append {
    position: absolute;
    z-index: 100;
    width: 30px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    right: 0;
    top: 0;
  }

  &__prepend-border {
    position: absolute;
    left: 30px;
    top: 0;
    z-index: 100;
    border-left: 1px solid var(--border-default);
    height: 100%;

    .ui-input_error + & {
      transition: all 0.3s ease 0s;
      border-color: var(--border-negative);
    }

    .ui-input_focused + & {
      transition: all 0.3s ease 0s;
      border-color: var(--border-focused);
    }
  }

  &__prepend:not(:empty) + .ui-input{
    width: 68px;
    .ui-input__wrapper {
      padding-left: 38px !important;
    }
  }
}
</style>
